export const MarketplaceOrderLabelTextHelper = {
    getLabelText: {
        orderId: 'Order ID',
        dateOrderOn: 'Order Date',
        orderNumber: 'Order Number',
        marketplaceCode: 'Marketplace Code',
        orderAmount: 'Order Amount',
        orderCurrencyCode: 'Order Currency',
        commissionPercentage: 'Commission Percentage',
        commissionAmount: 'Commission Amount',
        commissionCurrencyCode: 'Commission Currency',
        transactionFee: 'Transaction Fee',
        transactionFeeCurrencyCode: 'Transaction Fee Currency',
        remarks: 'Remarks',
        orderStatus: 'Order Status',
        refundStatus: 'Refund Status',
        paymentStatus: 'Payment Status',
        shippingFeeAmount: 'Shipping Fee (HKD)',
        orderBalanceAmount: 'Order Balance (HKD)',
        orderItemSkuList: 'Item SKU',
        dateCreateAt: 'Create date',
        dateModifyAt: 'Modify date',
        dateOrderOnFrom: 'Order Date From',
        dateOrderOnTo: 'Order Date To',
        action: 'Action'
    }
};
